<template>
  <div>
    <v-col cols="12">
      <GuardianFencePlate
        :item="inferenceCameraItem"
        ref="guardianFence"
      ></GuardianFencePlate>
    </v-col>

    <v-col cols="12">
      <v-btn color="primary" @click="updateFence">{{ $t("update") }}</v-btn>
    </v-col>
  </div>
</template>

<script>
import GuardianFencePlate from "@/components/guardian/GuardianFencePlate.vue";
import { getInferenceCameras } from "@/endpoint/inferenceCamera";

export default {
  name: "InferenceFence",
  components: {
    GuardianFencePlate,
  },
  data() {
    return {
      inferenceCameraItem: {},
      inferenceCameraItems: [],
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    async init(scope) {
      const inferenceCameraUuid = scope.$route.params.uuid;

      scope.inferenceCameraItems = await getInferenceCameras();

      scope.inferenceCameraItem = scope.inferenceCameraItems.find(function (
        item
      ) {
        return item._id == inferenceCameraUuid;
      });

      return scope;
    },
    updateFence() {
      this.$refs.guardianFence.updateFence();
    },
  },
};
</script>